import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import SaveIcon from '@mui/icons-material/Save';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import GenericAdminPageSkeleton from "../../../Skeleton/GenericAdminPageSkeleton";

const VisibilityType = Object.freeze({
  PRIVATE: "PRIVATE",
  PUBLIC: "PUBLIC",
  SYSTEM_DEFAULT: "SYSTEM_DEFAULT",
});

const CompanyVisibilityEditor = ({ classes = {}, disabled, onSave, visibility }) => {
  const [internalVisibility, setInternalVisibility] = useState();

  const handleChange = (e) => {
    setInternalVisibility(e.target.value);
  };

  const handleSave = () => {
    onSave?.(internalVisibility);
  };

  useEffect(() => {
    if (visibility) {
      setInternalVisibility(visibility);
    }
  }, [visibility]);

  if (!visibility || !internalVisibility) {
    return <GenericAdminPageSkeleton />;
  }

  return (
    <>
      <Box className={classes.headMarginBottom}>
        <Typography className={classes.headTitle}><FormattedMessage id="admin.companySettings.basicSettings.visibilitySetting.Title" /></Typography>
        <Typography className={classes.headSubTitle}><FormattedMessage id="admin.companySettings.basicSettings.visibilitySetting.subTitle" /></Typography>
      </Box>
      <Card>
        <CardContent className={classes.selectCard}>
          <Box sx={{ minWidth: 120, paddingTop: "25px" }}>
            <FormControl fullWidth>
              <TextField
                disabled={disabled}
                label={<FormattedMessage id="admin.companySettings.basicSettings.visibilitySetting.selectVisibilitySetting" />}
                onChange={handleChange}
                select
                value={(internalVisibility === VisibilityType.SYSTEM_DEFAULT) ? "" : internalVisibility}
              >
                <MenuItem value={VisibilityType.PUBLIC}><FormattedMessage id="admin.companySettings.basicSettings.visibilitySetting.public" /></MenuItem>
                <MenuItem value={VisibilityType.PRIVATE}><FormattedMessage id="admin.companySettings.basicSettings.visibilitySetting.private" /></MenuItem>
              </TextField>
            </FormControl>
          </Box>
        </CardContent>
        <CardContent sx={{ paddingBottom: "12px" }}>
          <Typography variant="body1" color="text.secondary" sx={{ fontSize: 16 }}>
            <FormattedMessage id="admin.companySettings.basicSettings.visibilitySetting.Clarification" />
          </Typography>
        </CardContent>
        <Divider />
        <CardActions sx={{ width: '100%', padding: "16px" }} className={classes.actionButtons}>
          <Button
            className={classes.btnDesign}
            disabled={(internalVisibility === visibility) || disabled}
            onClick={handleSave}
            size="small"
            startIcon={<SaveIcon />}
            variant="outlined"
          >
            <FormattedMessage id="btn.save" />
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

export default CompanyVisibilityEditor;
